import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=607cd724&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=607cd724&prod&lang=less&scoped=true"
import style1 from "./OrderList.vue?vue&type=style&index=1&id=607cd724&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607cd724",
  null
  
)

export default component.exports